import { render, staticRenderFns } from "./I18nGroup.vue?vue&type=template&id=bc5ef556&"
import script from "./I18nGroup.vue?vue&type=script&lang=js&"
export * from "./I18nGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports